import type { ComponentProps, ReactNode } from 'react';

import { Avatar } from '@playbook/atoms/avatar';

import css from './styles.module.css';

type AvatarHeaderEventHandlers = {
	[K in keyof ComponentProps<'div'> as K extends `on${string}`
		? K
		: never]?: ComponentProps<'div'>[K];
};

interface AvatarHeaderDataAttributes {
	[key: `data-${string}`]: string | number | boolean | undefined;
}

interface AvatarHeaderProperties
	extends AvatarHeaderEventHandlers, AvatarHeaderDataAttributes {
	label: string;
	avatarUrl?: string;
	alt?: string;
	initials?: string;
}

export function AvatarHeader({
	label,
	avatarUrl,
	alt = '',
	initials,

	...props
}: AvatarHeaderProperties): ReactNode {
	return (
		<div {...props} className={css.header}>
			<Avatar
				variant={avatarUrl ? 'picture' : 'initials'}
				size="sm"
				imageUrl={avatarUrl}
				alt={alt}
				initials={initials}
			/>
			<span className={css.label}>{label}</span>
		</div>
	);
}
